module.exports = __webpack_public_path__ + "static/media/kaa.7fd055de.ogg";